import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ArchiveIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Archive`} {...props}>
    <Path
      fill="currentColor"
      d="M10 7.25a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1 0-1.5h4Z"
    />
    <Path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 1.75a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-.25v6.25A1.75 1.75 0 0 1 12 14.25H4a1.75 1.75 0 0 1-1.75-1.75V6.25H2a.75.75 0 0 1-.75-.75v-3A.75.75 0 0 1 2 1.75h12ZM3.75 12.5c0 .138.112.25.25.25h8a.25.25 0 0 0 .25-.25V6.25h-8.5v6.25Zm-1-7.75h10.5v-1.5H2.75v1.5Z"
      clipRule="evenodd"
    />
  </Icon>
);
